import React from 'react';
import { observer } from 'mobx-react-lite';
import { IMInputText, IMSelect } from '@insurancemenu/imenu-components-lib';
import { IMSicSearch } from '@insurancemenu/imenu-components-lib/dist/components/imForm/capabilities/sic/IMSicSearch';
import SectionTitle from 'components/common/general/SectionTitle';
import DomainProductLines from 'components/common/initiate-proposal/DomainProductLines';
import {
  IMFormStyled,
  FollowingSectionTitleStyled,
  IMZipCodeFieldStyled,
  IMZipCountyFieldStyled,
  IMZipStateFieldStyled,
} from 'components/common/initiate-proposal/styles';
import { AlliedInitiateProposalFormDelegate } from 'store/pages/initiate-quote/allied/proposalFormDelegate';
import { ALLIED_INITIATE_PROPOSAL_FORM_ID } from './constants';

interface Props {
  proposalFormDelegate: AlliedInitiateProposalFormDelegate;
}

const AlliedInitiateProposalForm: React.FC<Props> = observer(({ proposalFormDelegate }) => {
  const { proposalForm, effectiveDatesOptions, domainProductLineItems, isDomainProductLinesLoading } =
    proposalFormDelegate;

  return (
    <IMFormStyled id={ALLIED_INITIATE_PROPOSAL_FORM_ID} formController={proposalForm}>
      <SectionTitle title="Basic Information" />
      <IMInputText label="Proposal Name" name="proposalName" size="full" />
      <IMSelect label="Effective Date" name="effectiveDate" size="full" options={effectiveDatesOptions} />
      <IMZipCodeFieldStyled size="s" />
      <IMZipStateFieldStyled size="s" />
      <IMZipCountyFieldStyled size="s" />

      <FollowingSectionTitleStyled title="Additional Information" />
      <IMSicSearch label="SIC Code" size="full" />

      <FollowingSectionTitleStyled title="Available Product Lines" />
      <DomainProductLines domainProductLineItems={domainProductLineItems} isLoading={isDomainProductLinesLoading} />
    </IMFormStyled>
  );
});

export default AlliedInitiateProposalForm;
